export default {"src":"/_next/static/media/myspace.ca71b20c.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};